import { EntMtsFilter } from "../../../models/filters/mtsFilter";
import { EntMts } from "../../../models/mts";

import { ResponseDataGet } from "../../../models/responseDataGet";
import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { Paths } from "../../../paths";
export const mtsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({

    getMtsListAll: builder.query<ResponseDataGet<EntMts>, EntMtsFilter>({
      query: (filter) => ({
        url: `${Paths.mechanization.mts}/get-all`,
        method: "POST",
        body: JSON.stringify(filter),
      }),
    }),

    getMtsById: builder.query<ResponseDataTest<EntMts>, number>({
      query: (id) => ({
        url: `${Paths.mechanization.mts}/${id}`,
        method: 'GET'
      })
    }),
    addMts: builder.mutation<ResponseDataTest<EntMts>, EntMts>({
      query: (body) => ({
        url: `${Paths.mechanization.mts}`,
        method: "POST",
        body: JSON.stringify(body)
      }),
    }),
    editMts: builder.mutation<ResponseDataTest<EntMts>, EntMts>({
      query: (body,) => ({
        url: `${Paths.mechanization.mts}`,
        method: 'PUT',
        body: JSON.stringify(body),
      }),
    }),
    deleteMts: builder.mutation<ResponseDataTest<EntMts>, number>({
      query: (id) => ({
        url: `${Paths.mechanization.mts}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddMtsMutation,
  useDeleteMtsMutation,
  useEditMtsMutation,
  useLazyGetMtsListAllQuery,
} = mtsApi;
